import { render } from "./GemeindeCard.vue?vue&type=template&id=30460e20&scoped=true"
import script from "./GemeindeCard.vue?vue&type=script&lang=js"
export * from "./GemeindeCard.vue?vue&type=script&lang=js"

import "./GemeindeCard.vue?vue&type=style&index=0&id=30460e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30460e20"]])

export default __exports__